import { Injectable } from '@angular/core';
import { AuthService } from './auth.service';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { catchError } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { QuestionAnswer } from '../_models/question-answer';

@Injectable()
export class QuestionAnswerService {

  constructor(private http: HttpClient, private authService : AuthService) { }

  public static readonly URL_QUESTIONANSWER_CONTROLLER = environment.apiUrl + '/question/';

  public static readonly URL_QUESTIONANSWER_LIST = QuestionAnswerService.URL_QUESTIONANSWER_CONTROLLER + "all/";
  public static readonly URL_QUESTIONANSWER_BY_ID = QuestionAnswerService.URL_QUESTIONANSWER_CONTROLLER + "getById/";
  public static readonly URL_SAVEANDUPDATE_QUESTIONANSWER = QuestionAnswerService.URL_QUESTIONANSWER_CONTROLLER + "saveAndUpdate/";
  public static readonly URL_DELETE_QUESTIONANSWER = QuestionAnswerService.URL_QUESTIONANSWER_CONTROLLER + "delete/"

  public static readonly URL_BASIC_OF_PATENT_QUESTIONANSWER = QuestionAnswerService.URL_QUESTIONANSWER_CONTROLLER + "basicOfPatentTest/";
  public static readonly URL_PATENTSEARCH_QUESTIONANSWER = QuestionAnswerService.URL_QUESTIONANSWER_CONTROLLER + "patentSearchTest/";
  public static readonly URL_PATENTDRAFT_QUESTIONANSWER = QuestionAnswerService.URL_QUESTIONANSWER_CONTROLLER + "patentDraftTest/";

// All Questions
getQuestionAnwerList() {
  let userToken: string = this.authService.getUserToken();
  return this.http.get(QuestionAnswerService.URL_QUESTIONANSWER_LIST + "/" + userToken)
   .pipe(catchError(this.handleError('Request Failed')));
}

// BasicofPatentSearch
getBasicOfPatentList() {
  let userToken: string = this.authService.getUserToken();
  return this.http.get(QuestionAnswerService.URL_BASIC_OF_PATENT_QUESTIONANSWER + "/" + userToken)
   .pipe(catchError(this.handleError('Request Failed')));
}

//save and update
saveAndUpdate(questionAnswerDataForm: QuestionAnswer) {
  console.log(questionAnswerDataForm);
  let userToken: string = this.authService.getUserToken();
  return this.http.post(QuestionAnswerService.URL_SAVEANDUPDATE_QUESTIONANSWER + userToken,questionAnswerDataForm)
    .pipe(catchError(this.handleError('Request Failed')));
}



// Patent search
getPatentSearch() {
  let userToken: string = this.authService.getUserToken();
  return this.http.get(QuestionAnswerService.URL_PATENTSEARCH_QUESTIONANSWER + "/" + userToken)
   .pipe(catchError(this.handleError('Request Failed')));
}

// Patent Draft
getPatentDraft() {
  let userToken: string = this.authService.getUserToken();
  return this.http.get(QuestionAnswerService.URL_PATENTDRAFT_QUESTIONANSWER + "/" + userToken)
   .pipe(catchError(this.handleError('Request Failed')));
}

getQuestionByID(id) {
  let userToken: string = this.authService.getUserToken();
  return this.http.post(QuestionAnswerService.URL_QUESTIONANSWER_BY_ID +id + '/'+userToken,id)
    .pipe(catchError(this.handleError('Request Failed')));
}


deleteQuestionAnswer(questionAnswerDataForm: QuestionAnswer) {
  let userToken: string = this.authService.getUserToken();
  let id = questionAnswerDataForm.questionId;
  return this.http.post(QuestionAnswerService.URL_DELETE_QUESTIONANSWER + id + '/' + userToken, id)
    // .pipe(catchError(this.handleError<Country>("list hero")))
    .pipe(catchError(this.handleError('Request Failed')));
}



private handleError<T>(operation = 'operation', result?: T) {
  return (error: HttpErrorResponse) => {
    console.log(error);
    if (error.status === 401) {
      localStorage.removeItem('currentUser');
      window.location.replace('');
    }
    return Observable.throw(error);
  };
}

}
